import SEO from "@components/seo";
import MainContent from "@components/content";
import Search from "@components/search";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import css from './index.module.css';
import { useScrollSave } from "@hooks/useScrollSave";
import { getCategoryIcon } from "./getCategoryIcon";

export default function RootPage() {
  const [categories, setCategories] = useState<any>([]);
  
  const { restoredData, isRestored, updateScrollY } = useScrollSave(
    'main_scroll',
    { categories },
    categories && categories.length > 0
  );

  useEffect(() => {
    if (restoredData) {
      setCategories(restoredData.categories);
    }
  }, [restoredData]);

  useEffect(() => {
    if (isRestored.current) {
      isRestored.current = false;
      return;
    }

    axios.get(`${import.meta.env.VITE_API_URL}/categories`, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      setCategories(response.data);
    }).catch(error => {
      console.log(error);
    });
  }, []);

  useEffect(() => {
    const container = document.getElementById('scrollable-content');
    if (container) {
      container.addEventListener('scroll', updateScrollY);
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', updateScrollY);
      }
    };
  }, [updateScrollY]);

  useEffect(() => {
    if (isRestored.current) {
      isRestored.current = false;
      return;
    }

    axios.get(`${import.meta.env.VITE_API_URL}/categories`, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      setCategories(response.data);
    }).catch(error => {
      console.log(error);
    });
  }, []);

  return (
    <MainContent header={'n'}>    
      <SEO 
        title="Главная"
        description="Магазин"
        ogUrl="https://рыбныимир.рф/"
      />

      <div className={css.header}>
        <Search />
      </div>

      <div className={`${css.categories}`}>
        {categories.map((category: any) => (
          <Link to={`/webapp/catalog/${category.id}`} key={category.id} className={css.category}>
            <div className={css.categoryContent}>
              {getCategoryIcon(category.name)}
              <span>{category.name}</span>
            </div>
            <i className="fi fi-rr-angle-right"></i>
          </Link>
        ))}
      </div>

    </MainContent>
  )
}